import { reactive } from 'vue'

/**
 * @function 创建表单的v-model
 * @description 依据表单的子控件的meta，自动创建model
 * @param { object } meta 表单子控件的meta
 */

export const createModel = (meta) => {
  const formModel = reactive({})
  meta.forEach((m) => {
    switch (parseInt(m.fieldType)) {
      case 1: //文本
        formModel[m.fieldCode] = m.defaultValue ? m.defaultValue : ''
        break
      case 2: //数字
        formModel[m.fieldCode] = m.defaultValue ? parseInt(m.defaultValue) : 1
        break
      case 3: //日期选择组件
        formModel[m.fieldCode] = 0
        break
      case 4: //文本域
        formModel[m.fieldCode] = m.defaultValue ? m.defaultValue : ''
        break
      case 5: //富文本组件
        formModel[m.fieldCode] = ''
        break
      case 6: //单选组件
        formModel[m.fieldCode] = ''
        break
      case 7: //复选组件
        formModel[m.fieldCode] = []
        break
      case 8: //上传图片
        formModel[m.fieldCode] = ''
        break
      case 9: //附件组件(包含图片、音频、视频)
        formModel[m.fieldCode] = ''
        break
      case 10: //下拉框组件
        formModel[m.fieldCode] = ''
        break
      case 11: //工单分类
        formModel[m.fieldCode] = ''
        break
      case 13: //系统字典组件
        formModel[m.fieldCode] = ''
        break
      case 21: //机构字典组件
        formModel[m.fieldCode] = ''
        break
    }
  })
  return formModel
}
